import { ItemType } from 'antd/es/menu/interface';
import { Session } from '@inhouse-market/sdk';
import { createElement } from 'react';
import { MenuLabel } from './MenuLabel';
import type { SidebarMenuItem } from './menu.types';

export type {
    SidebarBadge,
    SidebarItemMetadata,
    SidebarMenuItem,
} from './menu.types';

export function buildMenu(
    raw: SidebarMenuItem[],
    user: Session.Role[],
): ItemType[] {
    const userRoles = user.map((r) => r.type);

    const canView = (item: SidebarMenuItem) => {
        if (!item.roles) return true;

        return item.roles.some((role) => userRoles.includes(role));
    };

    const convert = (items: SidebarMenuItem[]): ItemType[] =>
        items.filter(canView).map((item) => ({
            key: item.key,
            icon: item.icon,
            label: createElement(MenuLabel, {
                label: item.label,
                meta: item.meta,
                suffixIcon: item.suffixIcon,
            }),
            path: item.path,
            ...(item.children ? { children: convert(item.children) } : {}),
        }));

    return convert(raw);
}
